export * from './usePermissionEvent2Detail';
